import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { SweetgreenLogoSvg } from '@sweetgreen/garnish';

import type { DesktopHeaderItemProps } from './DesktopHeader.types';

type DesktopHeaderLogoItemProps = DesktopHeaderItemProps;

export const DesktopHeaderLogoItem = (props: DesktopHeaderLogoItemProps) => (
  <Pressable accessibilityRole="button" {...props} style={styles.logoItem}>
    <SweetgreenLogoSvg />
  </Pressable>
);

const styles = StyleSheet.create({
  logoItem: {
    marginHorizontal: 20,
  },
});
